/**
 * @param {string} string
 * @returns {*}
 */
function camelize (string) {
  if (!string) return

  return string
    .replace(/[-_]+/g, ' ')
    .replace(/[^\w\s]/g, '')
    .replace(/ (.)/g, function ($1) {
      return $1.toUpperCase()
    })
    .replace(/ /g, '')
}

module.exports = { camelize }
